import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { User } from '../user/user.model';
import { PrioriteToDoEnum } from './periorite.todo.enum';
import { Emplacement } from '../emplacement/emplacement.model';
import { Media } from 'app/shared/service/media.service';
import { StatutTodoEnum } from './statut.todo.enum';

@Entity({ modelName: "Todo", uriName: "todos" })
export class Todo {
    @Key id: number;
    name: string;
    ref:string;
    statut : StatutTodoEnum;
    priorite: PrioriteToDoEnum;
    feedback:string;
    description: string;
    dateDemarrage: Date;
    ordre: number;
    urgent:boolean;
    hasSubtodos: boolean;
    user: User;
    piecesJointesAdmin: Media[];
    piecesJointesUser : Media[];
    emplacement: Emplacement;
    emplacementExterne : string;
    datePrevueDebut: Date;
    durationPrevue: number;
    durationRealisation: number;
    dateRealisationDebut: Date;
        constructor()
        {
            this.piecesJointesAdmin = [];
            this.piecesJointesUser = [];
        }
}